module.exports = __webpack_public_path__ + "static/media/title.40341f54.png";